module.exports = {"data":{"contentfulLayout":{"navigation":[{"title":"Home","url":"/"},{"title":"Portfolio","url":"/portfolio"}],"socialMedia":[{"network":"linkedin","url":"https://www.linkedin.com/in/dougmacklin"},{"network":"github","url":"https://github.com/dougmacklin"},{"network":"stack-overflow","url":"https://stackoverflow.com/users/1179207/dougmacklin"},{"network":"twitter","url":"https://twitter.com/dougmacklin"}]}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 122
// module chunks = 60335399758886 114276838955818